import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { ClienteSituacaoPipe, ClienteSituacaoColorPipe, ClienteSituacaoBadgePipe, ClienteSituacaoCadastrosFilterPipe } from './pipes';


@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteSituacaoPipe,
        ClienteSituacaoColorPipe,
        ClienteSituacaoBadgePipe,
        ClienteSituacaoCadastrosFilterPipe
    ],
    exports: [
        SharedModule,

        ClienteSituacaoPipe,
        ClienteSituacaoColorPipe,
        ClienteSituacaoBadgePipe,
        ClienteSituacaoCadastrosFilterPipe
    ],
    providers: [
        ClienteSituacaoPipe,
        ClienteSituacaoColorPipe,
        ClienteSituacaoBadgePipe,
        ClienteSituacaoCadastrosFilterPipe
    ]
})
export class ClienteSituacaoModule { }
